export default __webpack_public_path__ + "static/media/Head_2_Ear_2_C2.d4439d9e.svg";